import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import ScrollToTop from "../common/scroll/ScrollToTop";
import DashboardPage from "../pages/home/DashboardPage";
import {
  NewReceivedResponsePage,
  RequirementsInResolvingPage,
  ResolvedRequestsPage,
  AllRequestsPage,
  RequestArchivePage,
} from "../pages/requests/index";
import RequestPreviewDocumentsPage from "../pages/requests/overview/previewDocuments/RequestPreviewDocumentsPage";
import DocumentAcceptancePage from "../pages/requests/overview/previewDocuments/DocumentAcceptancePage";
import { cleanJoin } from "../utils/stringUtil";
import DecisionPreviewPage from "../pages/requests/overview/previewDocuments/DecisionAcceptance/DecisionPreviewPage";
import RequestVotingPage from "../pages/requests/RequestVotingPage";
import NewElections from "../pages/requests/elections/newElections/NewElections";
import GetElectionResults from "../pages/requests/elections/electionResults/GetElectionResults";
import AddNewVoters from "../pages/requests/elections/addNewVoters/AddNewVoters";

function Page({ user }) {
  const location = useLocation();

  return (
    <main
      className={cleanJoin(
        "content",
        location.pathname === user.applicationConfiguration.dashboardUri ? "ml-4 mr-4 mt-4" : ""
      )}
    >
      <Switch>
        <Route exact path={user.applicationConfiguration.dashboardUri}>
          <DashboardPage />
        </Route>
        <Route exact path="/receivedRequests">
          <NewReceivedResponsePage user={user} />
        </Route>
        <Route exact path={`/receivedRequests/:id/submissions/:uid/previewDocuments`}>
          <RequestPreviewDocumentsPage />
        </Route>
        <Route
          path={[
            `/receivedRequests/:id/submissions/:uid/previewDocuments/:document/:index/:additional/:additionalIndex`,
            `/receivedRequests/:id/submissions/:uid/previewDocuments/:document/:index/`,
          ]}
        >
          <DocumentAcceptancePage />
        </Route>
        <Route exact path="/requirementsInResolving">
          <RequirementsInResolvingPage />
        </Route>
        <Route exact path="/requirementsInResolving/upload/:id/previewDecision/:uid">
          <DecisionPreviewPage />
        </Route>
        <Route exact path="/resolvedRequests">
          <ResolvedRequestsPage />
        </Route>
        <Route exact path="/allRequests">
          <AllRequestsPage />
        </Route>
        <Route exact path="/archive">
          <RequestArchivePage />
        </Route>
        <Route exact path="/elections">
          <RequestVotingPage />
        </Route>
        <Route exact path="/elections/results">
          <GetElectionResults />
        </Route>
        <Route exact path="/elections/new">
          <NewElections />
        </Route>
        <Route exact path="/elections/add-new-voters">
          <AddNewVoters />
        </Route>
      </Switch>
      <ScrollToTop />
    </main>
  );
}

export default Page;
